import { Box } from "@mui/material";
import type { PropsWithChildren } from "react";
import Header from "./components/header/Header";

const Main = ({ children }: PropsWithChildren) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
      <Header />
      {children}
    </Box>
  );
};

export default Main;
